import { PropsWithChildren } from "react";

interface BoxProps extends PropsWithChildren {
    className?: string;
}

export function ContentHeader({ children, className }: BoxProps) {
    const additionalStyle = className ?? "";
    return (
        <h2
            className={
                "mb-20 font-semibold text-secondary-gray-dark text-xn " +
                additionalStyle
            }
        >
            {children}
        </h2>
    );
}
